import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ApprovalModel} from '../../../../shared/dto/approval.model';
import {BlacklistService} from '../../../../shared/service/blacklist.service';
import {Router} from '@angular/router';
import Swal,{default as swal}from 'sweetalert2';
import {ReversedBlacklistService} from '../../../../shared/service/reversed-blacklist.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ReversedSuspendService} from '../../../../shared/service/reversed-suspend.service';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import {ReversedSuspendBlacklistService} from '../../../../shared/service/reversed-suspend-blacklist.service';

@Component({
  selector: 'app-reversed-return-request',
  templateUrl: './reversed-return-request.component.html',
  styleUrls: ['./reversed-return-request.component.scss']
})
export class ReversedReturnRequestComponent implements OnInit {
  remarkForm: FormGroup;
  @Input() fromParent;
  approvalModel: ApprovalModel = new ApprovalModel();
  isError: boolean = false;
  isSucess: boolean = false;

  constructor(private blacklistService: ReversedBlacklistService, private router: Router,
              private reversedSuspendBlacklistService: ReversedSuspendBlacklistService,
              private activeModal: NgbActiveModal, private suspendService: ReversedSuspendService) { }

  ngOnInit() {
    this.approvalModel = this.fromParent.model;
    this.remarkForm = new FormGroup({
      remark: new FormControl(null),
    });
  }

  submitRequest() {
    this.approvalModel.remark = this.remarkForm.value.remark;

    if(this.approvalModel.process === ActionMode.REVERSE_SUSPEND) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to return the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.suspendService.returnRequest(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire('Success', 'Applicant Details Updated', 'success');
              this.activeModal.close({status: 'Saved', data: ""});

              if (this.router.url.includes('/dashboard/reversed-suspend-authorization/')) {
                this.router.navigate(['/dashboard/reversed-suspend-authorization']);

              }
              this.blacklistService.close();
            },
            (error) => {
              swal.fire('Error', 'Error When Updating the Request', 'error');
            },
          );
        } else {
        }
      });

    }else if(this.approvalModel.process === ActionMode.REVERSE_SUSPEND_BLACKLIST){
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to return the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.reversedSuspendBlacklistService.returnRequest(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire('Success', 'Applicant Details Updated', 'success');
              this.activeModal.close({status: 'Saved', data: ""});

              if(this.router.url.includes('/dashboard/reversed-suspend-blacklist-authorization/')) {
                this.router.navigate(['/dashboard/reversed-suspend-blacklist-authorization']);

              }

              this.blacklistService.close();
            },
            (error) => {
              swal.fire('Error', 'Error When Updating the Request', 'error');
            },
          );
        } else {
        }
      });

    }else{
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to return the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.blacklistService.returnRequest(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire('Success', 'Applicant Details Updated', 'success');
              this.activeModal.close({ status: 'Saved', data: "" });

              if(this.router.url.includes('/dashboard/reversed-blacklist-authorization/')) {
                this.router.navigate(['/dashboard/reversed-blacklist-authorization']);

              }
              this.blacklistService.close();
            },
            (error) => {
              swal.fire('Error', 'Error When Updating the Request', 'error');
            },
          );
        } else {
        }
      });
    }
  }

}
